import React, { useState, useEffect } from 'react'
import { onGetErrorMessage, onGetFormData, onInitForm } from '../../shared/utility'
import queryString from 'query-string'
import { private_server, public_server } from '../../config'

const useMasterclassesView = ({ is_auth, history, content, search_params, onUpdateSearchParams }) => {

    //Check if its the last page visited and has a saved search and filter
	let savedSearch = null
	let savedFilterValue = 0
	if(search_params && search_params.last_visited)
		if(search_params.last_visited === 'masterclasses'){
			savedSearch = search_params.search ? search_params.search : null;
			savedFilterValue = search_params.filter_value ? search_params.filter_value : 0;
		}

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(null)

    const [total, setTotal] = useState(0)
    const [search, setSearch] = useState(savedSearch)
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [filterValue, setFilterValue] = useState(savedFilterValue)
    const [tableFilter, setTableFilter] = useState({ limit: 9, offset: 0, order_by: 'id_masterclass', order: 0 })
    const [masterclasses, setMasterclasses] = useState([])

    //MODAL
    const [add_modal, setAddModal] = useState(false)

    useEffect(() => {
        if (is_auth)
            actions.onInitModule()
    }, [is_auth])

    useEffect(() => {
        if (is_auth)
            actions.onFilterMasterclass()
    }, [is_auth, tableFilter])

    useEffect(() => {
        if (is_auth)
            actions.onResetTableFilter()
    }, [is_auth, filterValue])

    const actions = {
        onInitModule: () => {
            window.scrollTo(0, 0)
            let _form = JSON.parse(JSON.stringify(formData))
            _form = onInitForm(_form, null, content.form)
            if(savedSearch)
				_form.search.value = savedSearch
            setForm(_form)
        },
        onResetTableFilter: () => setTableFilter({ limit: 9, offset: 0, order_by: 'id_masterclass', order: 0 }),
        onUpdateTableFilter: (data) => setTableFilter(data),
        onCloseSuccess: () => setSuccess(false),
        onCloseError: () => setError(null),
        onSearchMasterclass: async (data) => {
            let temp = { ...form }
            temp.search = { ...data }
            if (error) setError(null)
            setForm(temp)
            setSearch(data.value)
        },
        onUpdateFilterValue: (id) => setFilterValue(id),
        onFilterMasterclass: async () => {
            try {
                setLoading(true)
                let filter = { AND: [] }
                if (filterValue > 0) filter.AND.push({ field: "masterclass_status_id", operator: "=", value: filterValue })
                if (search && search.length > 0)
                    filter.AND.push({ field: "title", operator: "LIKE", value: `%%${search}%%` })
                let _filter = encodeURIComponent(JSON.stringify(filter))
                let params = filter.AND.length > 0 ? `?${queryString.stringify(tableFilter)}&filter=${_filter}` : `?${queryString.stringify(tableFilter)}`
                const _masterclasses = await private_server.get(`masterclass/all${params}`)
                setMasterclasses([..._masterclasses.data.data.masterclasses])
                setTotal(_masterclasses.data.data.count)
            } catch (error) {
                console.log(error)
                setError(onGetErrorMessage(error))
            }
            setLoading(false)
        },
        onVisitUrl: (url) => {
            if (url && url.length > 0){
                onUpdateSearchParams({search: search, filter_value: filterValue, last_visited: 'masterclasses'})
                history.push(`masterclasses/${url}`)
            }
        },
        onOpenAddModal: () => setAddModal(true),
        onCloseAddModal: () => setAddModal(false),
        onChange: (data) => {
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            if (error) setError(null)
            setForm(temp)
        },
        //HAY QUE CAMBIAR LA RUTA Y VER QUE DEVUELVE
        onSaveMasterclass: async () => {
            try {
                setSending(true)

                const data2send = onGetFormData(form)
                delete data2send.search

                let _masterclass = await private_server.post(`masterclass`, data2send)
                _masterclass = _masterclass.data.data.masterclasses
                setMasterclasses([...masterclasses, _masterclass])

                setError(null)
                setAddModal(false)
                setSending(false)
            } catch (error) {
                console.log(error)
                setSending(false)
                setError(onGetErrorMessage(error))
            }
        }
    }

    const system = { loading, sending, success, error }
    const view_data = { form, filterValue, masterclasses, add_modal, tableFilter, total }

    return { system, view_data, actions }
}

export default useMasterclassesView

const formData = {
    search: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'search',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    title: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'title',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    dimensions: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'dimensions',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    technique: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'technique',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    price: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'price',
            type: 'number',
            fullWidth: true,
        },
        rules: {
            type: 'number',
        }
    },
    description: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'description',
            type: 'text',
            fullWidth: true,
            multiline: true,
            rows: 4
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
    date: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'date',
            type: 'date',
            fullWidth: true,
        },
        rules: { type: 'date' }
    },
    sold: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'sold'
        }
    },
    nft: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'nft'
        }
    },
    external_url: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'external_url',
            type: 'text',
            fullWidth: true,
        },
        rules: {
            type: 'distance',
            min: 1,
            max: 200
        }
    },
}